import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import Settings from "./Setting";
import Common from "./Common";
import Dashboard from "./Dashboard";
import { leaveReducer } from "./Leave";
import { ashramwashiEventsReducer } from "./Events";
import { roomBookingReducer } from "./Room";
import { newsAndUpdateReducer } from "./NewsAndUpdates";
import { issueManagementReducer } from "./IssueManagement";
import { performanceReducer } from "./Performance";
import { masterReducer } from "./Master";
import { crmReducer } from "./Crm";
import { homeReducer } from "./Home";
import { areaMasterReducer } from "./AreaMaster";
import { attendenceReducer } from "./Attendence";
import { policyReducer } from "./Policies";
import { reportReducer } from "./Reports";

const reducers = (history) =>
    combineReducers({
        router: connectRouter(history),
        settings: Settings,
        dashboard: Dashboard,
        common: Common,
        master: masterReducer,
        leaveReducer: leaveReducer,
        ashramwashiEventsReducer: ashramwashiEventsReducer,
        roomBookingReducer: roomBookingReducer,
        newsAndUpdateReducer: newsAndUpdateReducer,
        issueManagementReducer: issueManagementReducer,
        performanceReducer: performanceReducer,
        crmReducer: crmReducer,
        homeReducer: homeReducer,
        areaMasterReducer: areaMasterReducer,
        attendenceReducer: attendenceReducer,
        policyReducer: policyReducer,
        reportReducer: reportReducer,
    });
export default reducers;
